import { useLeavesQuery } from "@/graphql/generated";

export function useFolderLeaves(
  text: string,
  folder: string | null,
  enabled: boolean,
) {
  const { data } = useLeavesQuery(
    { query: text, folder },
    { enabled: enabled && Boolean(folder) },
  );
  return (data?.leaves ?? []).map((leaf) => ({
    key: leaf.leaf,
    description: leaf.description,
  }));
}
